export const AD_RELATION_ATTEMPT = 'AD_RELATION_ATTEMPT';
export const AD_RELATION_SUCCESS = 'AD_RELATION_SUCCESS';
export const AD_RELATION_FAILED = 'AD_RELATION_FAILED';

export const LOGOUT = "LOGOUT";